import { defineComponent as _defineComponent } from 'vue'

  import { formatDate } from "@/helpers/date";
  import { formatPrice } from "@/helpers/transformation/price";
  import dayjs from "dayjs";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotOptions',
  props: {
    lot: {
      type: Object,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get formatDate() { return formatDate }, get formatPrice() { return formatPrice }, get dayjs() { return dayjs } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})